import React, { useState } from 'react';
import { MuiBox } from 'theme/material-ui';
import {
  MuiRow,
  PersonalInfoFormControl,
  PersonalInfoInputLabel,
  PersonalInfoSection,
  PreRegInputBox
} from '../styled';
import Config from 'react-native-config';
import { RaceSelectionList } from './RaceSelectionList';
import { KeyValue } from 'store/preRegistration/types';
import { convertRacesToWords } from '../utils';

const ALLOW_UPDATE = Config.PRE_REG_ALLOW_SAVE_PATIENT_DATA === 'enabled';

export default function RaceSelection({
  handleRaceChange,
  value,
  raceList
}: {
  handleRaceChange: (selectedRace: string[]) => void;
  value: string[];
  raceList: KeyValue[];
}) {
  const [displayRaces, setDisplayRaces] = useState<string>(convertRacesToWords(value, raceList));

  return (
    <MuiRow data-testid="race-selection">
      <MuiBox>
        <PersonalInfoInputLabel required={!!ALLOW_UPDATE}>Race</PersonalInfoInputLabel>
        <PersonalInfoSection>
          <PersonalInfoFormControl required={!!ALLOW_UPDATE}>
            <PreRegInputBox name="race" disabled value={displayRaces || 'Unavailable'} />
          </PersonalInfoFormControl>
          <RaceSelectionList
            patientInfoProps={value}
            handleRaceAccept={newRaces => {
              handleRaceChange(newRaces);
              setDisplayRaces(convertRacesToWords(newRaces, raceList));
            }}
            raceList={raceList}
          />
        </PersonalInfoSection>
      </MuiBox>
    </MuiRow>
  );
}
